/* eslint-disable import/prefer-default-export */

export const TEST_PHONE_VIRTUAL = 'TEST_PHONE_VIRTUAL'
export const SET_RUNTIME_VARIABLE = 'SET_RUNTIME_VARIABLE';

export const SET_BACK_URL = 'SET_BACK_URL';

export const HOME_FETCH_START = 'HOME_FETCH_START'
export const HOME_FETCH_END = 'HOME_FETCH_END'

export const HOME_FETCH_MORE_START = 'HOME_FETCH_MORE_START'
export const HOME_FETCH_MORE_END = 'HOME_FETCH_MORE_END'
export const HOME_SHOW_POP_UP = 'HOME_SHOW_POP_UP'
export const HOME_CLOSE_POP_UP = 'HOME_CLOSE_POP_UP'
export const HOME_HIDE_SLIDE_NAV = 'HOME_HIDE_SLIDE_NAV'

export const FETCH_USER_STATUS = 'FETCH_USER_STATUS'
export const FETCH_USER_REMIND = 'FETCH_USER_REMIND'
export const CANCEL_USER_REMIND = 'CANCEL_USER_REMIND'
export const LOG_IN = 'LOG_IN'
export const LOG_OUT = 'LOG_OUT'
export const USERS_BY_MOBILE = 'USERS_BY_MOBILE'

// export const UNBIND_MOBILE = 'UNBIND_MOBILE'
// export const SET_TOAST_MSG = 'SET_TOAST_MSG'

export const SEARCH_INIT = 'SEARCH_INIT'
export const FETCH_SEARCH_START = 'FETCH_SEARCH_START'
export const FETCH_SEARCH_END = 'FETCH_SEARCH_END'
export const FETCH_SEARCH_MORE_START = 'FETCH_SEARCH_MORE_START'
export const FETCH_SEARCH_MORE_END = 'FETCH_SEARCH_MORE_END'
export const DELETE_SEARCH_HISTORY = 'DELETE_SEARCH_HISTORY'

export const TAG_FETCH_START = 'TAG_FETCH_START'
export const TAG_FETCH_END = 'TAG_FETCH_END'
export const TAG_FETCH_MORE_START = 'TAG_FETCH_MORE_START'
export const TAG_FETCH_MORE_END = 'TAG_FETCH_MORE_END'
export const TAG_CHANGE_TAB = 'TAG_CHANGE_TAB'
export const TAG_ENTRIES_STORAGE = 'TAG_ENTRIES_STORAGE'

export const TALK_FETCH_START = 'TALK_FETCH_START'
export const TALK_FETCH_END = 'TALK_FETCH_END'
export const TALK_FETCH_MORE_START = 'TALK_FETCH_MORE_START'
export const TALK_FETCH_MORE_END = 'TALK_FETCH_MORE_END'
export const TALK_INIT = 'TALK_INIT'
export const TALK_CHANGE_TAB = 'TALK_CHANGE_TAB'

export const ADD_TALK = 'ADD_TALK'

export const SERIAL_FETCH_START = 'SERIAL_FETCH_START'
export const SERIAL_FETCH_END = 'SERIAL_FETCH_END'
export const SERIAL_FETCH_MORE_START = 'SERIAL_FETCH_MORE_START'
export const SERIAL_FETCH_MORE_END = 'SERIAL_FETCH_MORE_END'

export const COURSE_FETCH_START = 'COURSE_FETCH_START'
export const COURSE_FETCH_END = 'COURSE_FETCH_END'
export const COURSE_COMMENT_FETCH = 'COURSE_COMMENT_FETCH'
export const SHOW_COURSE_DIALOG = 'SHOW_COURSE_DIALOG'
export const HIDE_COURSE_DIALOG = 'HIDE_COURSE_DIALOG'

export const ORDER_FETCH_START = 'ORDER_FETCH_START'
export const ORDER_FETCH_END = 'ORDER_FETCH_END'

export const MYCOURSE_FETCH_START = 'MYCOURSE_FETCH_START'
export const MYCOURSE_FETCH_END = 'MYCOURSE_FETCH_END'

export const MYCOURSE_DATA_FETCH_START = 'MYCOURSE_DATA_FETCH_START'
export const MYCOURSE_DATA_FETCH_END = 'MYCOURSE_DATA_FETCH_END'

export const MYORDER_FETCH_END = 'MYORDER_FETCH_END'
export const MYORDER_FETCH_START = 'MYORDER_FETCH_START'

export const ADULTORDER_FETCH_START = 'ADULTORDER_FETCH_START'
export const ADULTORDER_FETCH_END = 'ADULTORDER_FETCH_END'

export const ORDER_CANCEL_REASONS_FETCH = 'ORDER_CANCEL_REASONS_FETCH'

export const BIND_MOBILE = 'BIND_MOBILE'

export const SET_BIND_STATUS = 'SET_BIND_STATUS'
export const FETCH_LOGIN_INFO = 'FETCH_LOGIN_INFO'

export const SERIALCOURSE_FETCH_START = 'SERIALCOURSE_FETCH_START'
export const SERIALCOURSE_FETCH_END = 'SERIALCOURSE_FETCH_END'

export const COUPON_COURSE_PACKAGE = 'COUPON_COURSE_PACKAGE'; // 套餐优惠券

export const FETCH_XBK_CONFIG = 'FETCH_XBK_CONFIG'

export const VALID_URL_REG = /^http[s]?:\/\/(\w*\.)*((163\.com)|(youdao\.com)|(ydstatic\.com)|(126\.com)|(huihui\.com))(:\d{2,5})?(\/.*)?$/

export const QUALIFICATION = [
  {
    name: '网易公司',
    url: 'http://www.163.com/',
  },
  {
    name: '隐私政策',
    url: 'http://c.youdao.com/xue/legal.html',
  },
  {
    name: '服务条款',
    url: 'http://c.youdao.com/xue/agreement.html',
  },
  {
    name: '中小学生校外培训服务合同',
    url: 'https://c.youdao.com/xue/k12contract.html',
  },
  {
    name: '有道精品课课程备案内容承诺书',
    url: 'https://c.youdao.com/xue/commitment.html',
  },
  {
    name: '公司证照',
    url: 'https://c.youdao.com/xue/license.html',
  },
]



// WEBPACK FOOTER //
// ./src/constants/index.js